function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useSetAtom, useAtomValue } from 'jotai';
import { ChevronDownIcon, ChevronUpIcon, PlusCircleIcon } from '@heroicons/react/24/outline';

import { Translate } from "../../../../../I18N";


import { FetchResponseError } from "../../../../../../shared/JSONRequest";






import * as filesAPI from "../../../../api/files";
import * as entitiesAPI from "../../../../api/entities";
import { secondsToISODate } from "../../../../shared/dateHelpers";
import { Button, Sidepanel } from "../../../../Components/UI";
import { InputField, MultiselectList } from "../../../../Components/Forms";
import { PDF, selectionHandlers } from "../../../../Components/PDFViewer";
import { notificationAtom, pdfScaleAtom, thesauriAtom } from "../../../../atoms";


const SELECT_TYPES = ['select', 'multiselect', 'relationship'];var









HighlightColors = /*#__PURE__*/function (HighlightColors) {HighlightColors["CURRENT"] = "#B1F7A3";HighlightColors["NEW"] = "#F27DA5";return HighlightColors;}(HighlightColors || {});




const getFormValue = (
suggestion,
entity,
type) =>
{
  let value;

  if (!suggestion || !entity) {
    return value;
  }

  if (suggestion.propertyName === 'title' && entity.title) {
    value = entity.title;
  }

  if (suggestion.propertyName !== 'title' && entity.metadata) {
    const entityMetadata = entity.metadata[suggestion.propertyName];
    value = entityMetadata !== null && entityMetadata !== void 0 && entityMetadata.length ? entityMetadata[0].value : '';

    if (type === 'date' && value) {
      const dateString = secondsToISODate(value);
      value = dateString;
    }

    if (type === 'select' || type === 'multiselect' || type === 'relationship') {
      value = entityMetadata === null || entityMetadata === void 0 ? void 0 : entityMetadata.map((metadata) => metadata.value);
    }
  }

  return value;
};

const loadSidepanelData = async ({ fileId, entityId, language }) => {
  const [file, entity] = await Promise.all([
  filesAPI.getById(fileId),
  entitiesAPI.getById({ _id: entityId, language })]
  );

  return { file: file[0], entity: entity[0] };
};

const handleFileSave = async (file, newSelections) => {
  if (file && newSelections) {
    const fileToSave = _objectSpread({}, file);
    fileToSave.extractedMetadata = newSelections;
    return filesAPI.update(fileToSave);
  }

  return undefined;
};

const handleEntitySave = async (
entity,
propertyName,
metadata,
fieldHasChanged) =>
{
  if (!fieldHasChanged || !entity || !propertyName) {
    return undefined;
  }

  let data;

  if (propertyName === 'title' && typeof metadata === 'string') {
    data = { title: metadata };
  } else {
    data = { properties: [{ [propertyName]: metadata }] };
  }

  const entityToSave = entitiesAPI.formatter.update(entity, data);

  return entitiesAPI.save(entityToSave);
};

const coerceValue = async (
propertyType,
text,
documentLanguage = 'en') =>
{
  if (propertyType === 'date' && !Number.isNaN(text === null || text === void 0 ? void 0 : text.valueOf())) {
    return entitiesAPI.coerceValue(text, 'date', documentLanguage);
  }

  if (propertyType === 'numeric' && typeof text === 'string') {
    return entitiesAPI.coerceValue(text.trim(), 'numeric', documentLanguage);
  }

  return undefined;
};

const PDFSidepanel = ({
  showSidepanel,
  setShowSidepanel,
  suggestion,
  onEntitySave,
  property
}) => {
  const [pdf, setPdf] = useState();
  const [selectedText, setSelectedText] = useState();
  const [selectionError, setSelectionError] = useState();
  const [highlights, setHighlights] = useState();
  const [selections, setSelections] = useState(undefined);
  const [labelInputIsOpen, setLabelInputIsOpen] = useState(true);
  const [entity, setEntity] = useState();
  const [thesaurus, setThesaurus] = useState();
  const setNotifications = useSetAtom(notificationAtom);
  const thesauris = useAtomValue(thesauriAtom);
  const templateId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.entityTemplateId;
  const [initialValue, setInitialValue] = useState();
  const [selectAndSearch, setSelectAndSearch] = useState(false);
  const [selectAndSearchValue, setSelectAndSearchValue] = useState();
  const [options, setOptions] = useState([]);
  const pdfScalingValue = useAtomValue(pdfScaleAtom);

  useEffect(() => {
    if (suggestion) {
      setInitialValue(getFormValue(suggestion, entity, property === null || property === void 0 ? void 0 : property.type));
    }
  }, [suggestion, entity, property]);

  useEffect(() => {
    if (selectAndSearch) {
      setSelectAndSearchValue(selectedText === null || selectedText === void 0 ? void 0 : selectedText.text);
    } else {
      setSelectAndSearchValue(undefined);
    }
  }, [selectAndSearch, setSelectAndSearchValue, selectedText]);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    control,
    watch,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    values: {
      field: initialValue
    }
  });

  const watchField = watch('field');

  useEffect(() => {
    const renderLabel = (value) => {
      const matchingStyles = 'bg-success-50 text-success-800';
      const nonMatchingStyles = 'bg-orange-50 text-orange-800';
      const currentValues = getValues('field') || [];
      const suggestions = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.suggestedValue) || [];
      const isSelected = currentValues.includes(value.id);
      const isSuggested = suggestions.includes(value.id);
      let styles = '';

      if (isSelected && isSuggested) {
        styles = matchingStyles;
      }

      if (!isSelected && isSuggested) {
        styles = nonMatchingStyles;
      }
      return (/*#__PURE__*/
        _jsx(Translate, { className: styles, context: property === null || property === void 0 ? void 0 : property.content }, void 0,
        value.label
        ));

    };

    const _options = [];

    thesaurus === null || thesaurus === void 0 ? void 0 : thesaurus.values.forEach((value) => {var _suggestion$suggested, _value$values;
      _options.push({
        label: renderLabel(value),
        searchLabel: value.label.toLowerCase(),
        value: value.id,
        suggested: suggestion === null || suggestion === void 0 ? void 0 : (_suggestion$suggested = suggestion.suggestedValue) === null || _suggestion$suggested === void 0 ? void 0 : _suggestion$suggested.includes(value.id),
        items: (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.map((subValue) => {var _suggestion$suggested2;return {
            label: renderLabel(subValue),
            searchLabel: subValue.label.toLowerCase(),
            value: subValue.id,
            suggested: suggestion === null || suggestion === void 0 ? void 0 : (_suggestion$suggested2 = suggestion.suggestedValue) === null || _suggestion$suggested2 === void 0 ? void 0 : _suggestion$suggested2.includes(subValue.id)
          };})
      });
    });
    setOptions(_options);
  }, [getValues, property, suggestion, thesaurus, watchField]);

  useEffect(() => {
    if (property !== null && property !== void 0 && property.content) {
      const _thesaurus = thesauris.find((thes) => thes._id === property.content);
      setThesaurus(_thesaurus);
    }

    return () => {
      setThesaurus(undefined);
    };
  }, [property, thesauris]);

  useEffect(() => {
    if (suggestion) {
      loadSidepanelData(suggestion).
      then(({ file, entity: suggestionEntity }) => {
        setPdf(file);
        setEntity(suggestionEntity);
      }).
      catch((e) => {
        throw e;
      });
    }

    return () => {
      setPdf(undefined);
      setEntity(undefined);
    };
  }, [suggestion]);

  useEffect(() => {
    if (pdf !== null && pdf !== void 0 && pdf.extractedMetadata && suggestion && showSidepanel) {
      setSelectedText(undefined);
      setHighlights(
        selectionHandlers.getHighlightsFromFile(
          pdf.extractedMetadata,
          suggestion.propertyName,
          HighlightColors.CURRENT
        )
      );
    }

    return () => {
      setSelectedText(undefined);
      setSelectionError(undefined);
      setHighlights(undefined);
      setSelections(undefined);
      setValue('field', undefined, { shouldDirty: false });
    };
  }, [pdf, setValue, showSidepanel, suggestion]);

  const onSubmit = async (value) =>

  {
    if (!property) {
      throw new Error('Property not found');
    }

    let metadata = value.field;

    if (property.type === 'date' && isDirty && metadata) {var _await$coerceValue;
      metadata = (_await$coerceValue = await coerceValue('date', metadata, (pdf === null || pdf === void 0 ? void 0 : pdf.language) || 'en')) === null || _await$coerceValue === void 0 ? void 0 : _await$coerceValue.value;
    }

    const [savedFile, savedEntity] = await Promise.all([
    handleFileSave(pdf, selections),
    handleEntitySave(entity, property.name, metadata, isDirty)]
    );

    if (savedFile instanceof FetchResponseError || savedEntity instanceof FetchResponseError) {
      const details =
      (savedFile === null || savedFile === void 0 ? void 0 : savedFile.json.prettyMessage) || (
      savedEntity === null || savedEntity === void 0 ? void 0 : savedEntity.json.prettyMessage);

      setNotifications({ type: 'error', text: 'An error occurred', details });
    } else if (savedFile || savedEntity) {
      if (savedFile) {
        setPdf(savedFile);
      }

      if (savedEntity) {
        setEntity(savedEntity);
        onEntitySave(savedEntity);
      }

      setNotifications({ type: 'success', text: 'Saved successfully.' });
    }

    setShowSidepanel(false);
  };

  const handleClickToFill = async () => {
    if (!property) {
      throw new Error('Property not found');
    }

    if (selectedText) {
      const normalizedSelections = selectionHandlers.adjustSelectionsToScale(
        selectedText,
        pdfScalingValue,
        true
      );

      setHighlights(
        selectionHandlers.getHighlightsFromSelection(normalizedSelections, HighlightColors.NEW)
      );
      setSelections(
        selectionHandlers.updateFileSelection(
          { name: (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName) || '', id: property._id },
          pdf === null || pdf === void 0 ? void 0 : pdf.extractedMetadata,
          normalizedSelections
        )
      );

      if (property.type === 'date' || property.type === 'numeric') {
        const coercedValue = await coerceValue(
          property.type,
          normalizedSelections.text,
          pdf === null || pdf === void 0 ? void 0 : pdf.language
        );

        if (!(coercedValue !== null && coercedValue !== void 0 && coercedValue.success)) {
          setSelectionError('Value cannot be transformed to the correct type');
        }

        if (coercedValue !== null && coercedValue !== void 0 && coercedValue.success) {
          setValue('field', secondsToISODate(coercedValue.value), { shouldDirty: true });
          setSelectionError(undefined);
        }
      } else {
        setValue('field', normalizedSelections.text, { shouldDirty: true });
      }
    }
  };

  const renderInputText = (type) => {var _errors$field;
    if (!property) {
      return null;
    }
    const inputType = type === 'numeric' ? 'number' : type;
    return (/*#__PURE__*/
      _jsx("div", { className: `relative flex gap-2 px-4 pb-4 grow  ${labelInputIsOpen ? '' : 'hidden'}` }, void 0, /*#__PURE__*/
      _jsx("div", { className: "grow" }, void 0, /*#__PURE__*/
      React.createElement(InputField, _extends({
        clearFieldAction: () => {
          setValue('field', '');
        },
        id: property.label,
        label: /*#__PURE__*/_jsx(Translate, { context: templateId }, void 0, property.label),
        hideLabel: true,
        type: inputType,
        hasErrors: ((_errors$field = errors.field) === null || _errors$field === void 0 ? void 0 : _errors$field.type) === 'required' || !!selectionError },
      register('field', {
        required: property.required,
        valueAsDate: property.type === 'date' || undefined
      }))
      )
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Button, {
        type: "button",
        styling: "outline",
        onClick: async () => handleClickToFill(),
        disabled: !(selectedText !== null && selectedText !== void 0 && selectedText.selectionRectangles.length) || isSubmitting }, void 0, /*#__PURE__*/

      _jsx(Translate, { className: "" }, void 0, "Click to fill")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "sm:text-right", "data-testid": "ix-clear-button-container" }, void 0, /*#__PURE__*/
      _jsx(Button, {
        type: "button",
        styling: "outline",
        disabled: Boolean(!highlights) || isSubmitting,
        onClick: () => {
          setHighlights(undefined);
          setSelections(
            selectionHandlers.deleteFileSelection(
              { name: (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName) || '' },
              pdf === null || pdf === void 0 ? void 0 : pdf.extractedMetadata
            )
          );
        } }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Clear")
      )
      )
      ));

  };

  const renderSelect = (type) => /*#__PURE__*/
  _jsx("div", { className: `px-4 pb-4 overflow-y-scroll grow ${labelInputIsOpen ? '' : 'hidden'}` }, void 0, /*#__PURE__*/
  _jsx(Controller, {
    control: control,
    name: "field",
    rules: { required: property === null || property === void 0 ? void 0 : property.required },
    render: ({ field: { onChange, value } }) => /*#__PURE__*/
    _jsx(MultiselectList, {
      onChange: onChange,
      value: value,
      items: options,
      checkboxes: true,
      singleSelect: type === 'select',
      search: selectAndSearchValue,
      suggestions: true }
    ) }

  )
  );


  const renderForm = () => {
    switch (property === null || property === void 0 ? void 0 : property.type) {
      case 'text':
      case 'date':
      case 'numeric':
        return renderInputText(property === null || property === void 0 ? void 0 : property.type);
      case 'select':
      case 'multiselect':
      case 'relationship':
        return renderSelect(property === null || property === void 0 ? void 0 : property.type);
      default:
        return '';
    }
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      size: "large",
      title: entity === null || entity === void 0 ? void 0 : entity.title,
      closeSidepanelFunction: () => setShowSidepanel(false) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex-grow overflow-y-scroll" }, void 0, /*#__PURE__*/
    _jsx("form", {
      id: "ixpdfform",
      className: "flex flex-col h-full gap-4 p-0",
      onSubmit: handleSubmit(onSubmit) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "grow" }, void 0,
    pdf && /*#__PURE__*/
    _jsx(PDF, {
      fileUrl: `/api/files/${pdf.filename}`,
      highlights: highlights,
      onSelect: (selection) => {
        if (!selection.selectionRectangles.length) {
          setSelectionError('Could not detect the area for the selected text');
          setSelectedText(undefined);
        } else {
          setSelectionError(undefined);
          setSelectedText(selection);
        }
      },
      onDeselect: () => {
        setSelectionError(undefined);
        setSelectedText(undefined);
      },
      scrollToPage: !selectedText ? Object.keys(highlights || {})[0] : undefined }
    )

    )
    ), ' '
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, {
      className: `max-h-[40%] ${labelInputIsOpen && ['select', 'multiselect', 'relationship'].includes((property === null || property === void 0 ? void 0 : property.type) || '') ? 'h-[40%]' : ''}` }, void 0, /*#__PURE__*/

    _jsx("div", { className: "relative flex flex-col h-full py-0 border border-b-0 border-l-0 border-r-0 border-gray-200 border-t-1" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sticky top-0 flex px-4 py-2 bg-gray-50" }, void 0, /*#__PURE__*/
    _jsx("p", { className: selectionError ? 'text-pink-600 grow  flex gap-4' : 'grow flex gap-4' }, void 0, /*#__PURE__*/
    _jsx(Translate, {
      className: "font-semibold leading-6 text-gray-500 uppercase ",
      context: templateId }, void 0,

    property === null || property === void 0 ? void 0 : property.label
    ), ' ',
    SELECT_TYPES.includes((property === null || property === void 0 ? void 0 : property.type) || '') && /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: () => setSelectAndSearch((old) => !old),
      className: `${selectAndSearch ? 'bg-primary-50 border-primary-800' : 'bg-white border-gray-200'} border flex items-center gap-1 px-2 py-0 text-xs font-medium text-gray-900 rounded-md hover:border-primary-800 hover:bg-primary-50` }, void 0, /*#__PURE__*/

    _jsx(PlusCircleIcon, { className: "w-3" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Select & Search")
    ),

    selectionError && /*#__PURE__*/_jsx("span", {}, void 0, selectionError)
    ), /*#__PURE__*/
    _jsx("span", { onClick: () => setLabelInputIsOpen((old) => !old), className: "cursor-pointer" }, void 0,
    labelInputIsOpen ? /*#__PURE__*/_jsx(ChevronDownIcon, { width: 20 }) : /*#__PURE__*/_jsx(ChevronUpIcon, { width: 20 })
    )
    ),
    renderForm(), /*#__PURE__*/
    _jsx("div", { className: "sticky bottom-0 flex justify-end gap-2 px-4 py-2 bg-white border border-b-0 border-l-0 border-r-0 border-gray-200 border-t-1" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "outline",
      disabled: isSubmitting,
      onClick: () => {
        setShowSidepanel(false);
        reset();
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { type: "submit", form: "ixpdfform", disabled: isSubmitting, color: "success" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Accept")
    )
    )
    )
    )
    ));

};

export { PDFSidepanel };